/**
 * 时长打点
 */
import { HelperCore, EE } from "@src/common/dependencies";
import appLogger from "./monitor";

const ONLY_REPORT_IN_CHAT = true;

const DEFAULT_LOGTIME_DATA = {
  data : null,      // 当前正在打点的页面标识
  beginTime : 0,    // 当前正在打点的页面开始的时间
  lastTime : 0,     // 当前正在打点的页面上次打点的时间
  curSep : 0,       // 本次打点间隔
}

const isSameData = (a, b) => {
  if(!!a != !!b){
    return false;
  }
  if(!a){
    return true;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  return keysA.length == keysB.length && keysA.every(key => a[key] == b[key]);
}

class TimeLogger {
  logKey = "";
  timerLogTime = null;
  logTimeData = HelperCore.copyObj(DEFAULT_LOGTIME_DATA);

  constructor (eventType, logKey = 'aiso_public') {
    if(!eventType || typeof eventType != "string"){
      throw new Error(`时长打点需要事件类型 ${eventType}`);
    }

    this.logKey = logKey;
    EE.on(eventType, data => {
      if(isSameData(data, this.logTimeData.data)){
        return;
      }

      this.doLogTime(data);
    });
  }

  /**
   * 时长打点
   * 10s内，每2s打一次
   * 10~60s内，每5s打一次
   * 60s以上，每10s打一次
   * 切换页面时，打上尾巴
   * @param {String} pathname 
   */
  getLogTimeNextSep () {
    // 固定间隔
    return 5000;

    const { beginTime } = this.logTimeData;
    const sep = +new Date - beginTime;
    if(sep >= 60000){
      return 10000;
    }
    if(sep >= 10000){
      return 5000;
    }
    return 2000;
  }
  /**
   * 页面标识
   * @param {Object} data 
   * @example
   *    doLogTime({
   *      ext1 : "",
   *      ext2 : "",
   *    });
   *
   *    doLogTime(null);
   */
  doLogTime = (data) => {
    // debug
    // HelperCore.log(`时长打点`, data, this.logTimeData);

    if(typeof data != "object"){
      console.error(`打点标识不正确`, data);
      return;
    }

    const now = +new Date;
    clearTimeout(this.timerLogTime);
    let isNew = false;

    // 与上次不一样
    if(!isSameData(data, this.logTimeData.data)){
      isNew = true;
      // 了结上一个页面
      if(this.logTimeData.data){
        const sep = Math.max(0, now - this.logTimeData.lastTime);
        const logData = {
          key : this.logKey,
          action : "time",
          ext : sep,
          ...this.logTimeData.data,
        };

        // 是否当前 tab
        if(this.logKey == "aiso_public" && !logData.status){
          logData.status = document.hidden ? 'notab' : 'tab';
        }

        this.sendLog(logData);
      }

      this.logTimeData = {
        data,
        beginTime : now,
        lastTime : now,
      }
    }

    // 中止打点
    if(!this.logTimeData.data){
      this.logTimeData = HelperCore.copyObj(DEFAULT_LOGTIME_DATA);
      return;
    }
    
    const nextSep = this.getLogTimeNextSep();
    this.timerLogTime = setTimeout(() => {
      const logData = {
        key : this.logKey,
        action : "time",
        ext : nextSep,
        arrt : isNew ? "first" : "",
        ...this.logTimeData.data,
      }

      // 是否当前 tab
      if(this.logKey == "all_page" && !logData.status){
        logData.status = document.hidden ? 'notab' : 'tab';
      }

      this.sendLog(logData);

      this.logTimeData.lastTime = +new Date;
      this.doLogTime(this.logTimeData.data);
    }, nextSep);
  }
  
  /**
   * @param {Object} logData 
   * @returns 
   */
  sendLog (logData) {
    // 只保留会话页时长上报
    if(ONLY_REPORT_IN_CHAT && !/^\/chat\//.test(location.pathname)){
      return;
    }

    appLogger.log(logData);
  }
}

export default TimeLogger;